export default __webpack_public_path__ + "static/dd-construction-d38dab98972636e90e5dc499c8fae315.jpg";